import { Box, TextField } from '@mui/material';
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import '../../../FrontOffice/IPPatients/PatientsDetails/ClinicalNotes/DoctorNotes.css'
import { CommonEditButton, CommonDeleteButton } from '../../../../Components/Common Components/CommonComponents';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import ShowComponents from '../Common/ShowComponent';
import { debounce } from '../../../../Components/CommonFunctions/CommonFunctions';
import RestAPIService from '../../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../../Utility/API/Serviceurls'

const debouncedApiCall = debounce((apiCall) => apiCall(), 500);

class DocNewLayoutLeft extends Component {
    constructor(props) {
        super(props)
        this.state = {
            comments: "",
            stateKey: "",
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        }
    }

    componentDidMount() {
        if (this.props.stateValue) {
            this.updateState();
        }
    }

    componentDidUpdate(prevProps) {
        if ((prevProps.stateValue !== this.props.stateValue) && this.props.stateValue) {
            this.updateState();
        }
    }

    updateState = () => {
        if (Object.keys(this.props.stateValue)?.length > 0) {
            const { stateValue, stateKey } = this.props;
            this.setState({
                comments: stateValue?.comments || "",
                stateKey: stateKey || "",
            })
        }
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message
        })
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    onEditHandler() {
        this.props.EditNewLayoutText(this.state.comments, this.props.stateKey)
    }

    PostNewLayoutComments = () => {
        try {
            const { stateValue, custom_name, PatientData } = this.props;
            let data = {
                "appointment_id": PatientData?.appointment_id,
                "patient_id": PatientData?.patient_id,
                "system_name": stateValue?.system_name,
                "custom_name": custom_name,
                "comments": ""
            }

            RestAPIService.create(data, Serviceurls.DOC_NEW_LAYOUT_GET)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.successMessage(response.data.message)
                        this.props.GetAPiCall()
                    } else {
                        this.errorMessage(response.data.message)
                    }
                }).catch(error => {
                    this.errorMessage(error.response.data.message || error.message)
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    render() {
        return (
            <ShowComponents onIntersection={() => debouncedApiCall(this.props.GetAPiCall)}>
                <Box height={'20vh'} display={'flex'} flexDirection={'row'}>
                    <TextField
                        size='small'
                        className='eMed_DocNotes_ProvDiag_TextField'
                        multiline={true}
                        rows={5}
                        label={this.props.custom_name ? this.props.custom_name : this.props.stateValue?.system_name}
                        value={this.state.comments}
                        InputProps={{ readOnly: true }}
                    />
                    <Box marginTop={'0.3vw'} sx={{ display: 'flex', flexDirection: 'column' }}>
                        <CommonEditButton size={"1.5vw"} disable={this.props?.isLocked || !this.state.comments} onClick={this.onEditHandler.bind(this)} />
                        <CommonDeleteButton size={"1.5vw"} disable={this.props?.isLocked || !this.state.comments} onClick={this.PostNewLayoutComments.bind(this)} />      
                    </Box>
                    {this.state.isErrorMsg ?
                        <ToastMsg
                            severity={'error'}
                            msg={this.state.isErrorMsgText}
                            msgPop={this.msgClose.bind(this)}
                        />
                        : null}
                    {this.state.successMsg ?
                        <ToastMsg
                            severity={'success'}
                            msg={this.state.successMsgText}
                            msgPop={this.msgClose.bind(this)}
                        />
                        : null}
                </Box>
            </ShowComponents>
        )
    }
}
export default withTranslation()(DocNewLayoutLeft)